import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api from "../api/client";

export function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = searchParams.get("session_id");
  const [status, setStatus] = useState<"loading" | "ok" | "error">("loading");
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!sessionId) {
      setStatus("error");
      setMessage("Missing payment session. Return to the course and try again.");
      return;
    }
    let cancelled = false;
    let timer: number | undefined;
    api
      .post("/checkout/verify", { sessionId })
      .then((res) => {
        if (cancelled) return;
        if (res.data.success) {
          setStatus("ok");
          setMessage("Payment confirmed. Redirecting…");
          const d = res.data.data;
          timer = window.setTimeout(() => {
            if (cancelled) return;
            if (d?.kind === "course" && d?.slug) {
              navigate(`/dashboard/courses/${d.slug}`);
            } else {
              navigate("/dashboard");
            }
          }, 1200);
          return;
        }
        setStatus("error");
        setMessage(res.data.message || "Could not confirm payment.");
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        setStatus("error");
        const msg = (err as { response?: { data?: { message?: string } } })?.response?.data?.message;
        setMessage(msg || "Could not confirm payment.");
      });
    return () => {
      cancelled = true;
      if (timer) window.clearTimeout(timer);
    };
  }, [sessionId, navigate]);

  return (
    <div className="min-h-full bg-stone/40 flex items-center justify-center px-4 py-16">
      <div className="rounded-2xl border border-gray-200 bg-white p-10 shadow-soft max-w-md w-full text-center">
        {status === "loading" && (
          <>
            <div className="animate-pulse h-10 w-10 rounded-full bg-gold-200 mx-auto" />
            <p className="mt-6 text-gray-700 font-medium">Confirming your payment…</p>
          </>
        )}
        {status === "ok" && (
          <>
            <div className="w-14 h-14 mx-auto rounded-full bg-green-100 flex items-center justify-center text-green-600">
              <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <p className="mt-4 text-green-800 font-medium">{message}</p>
          </>
        )}
        {status === "error" && (
          <>
            <p className="text-red-600 font-medium">{message}</p>
            <Link to="/dashboard" className="mt-6 inline-block font-semibold text-gold-500 hover:text-gold-400">
              Go to dashboard
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
